import { DialogModeType } from '../shared/error/dialog-message-type.enum';
import { MessageCode } from '../shared/error/user-message';

export class ErrorDialogData {
  public message: string;
  public messageCode?: MessageCode;
  public error?: any;
  public description?: string;
  public showLoginBtn?: boolean;
  public disableClose?: boolean;
  public mode?: DialogModeType;

  constructor(mode: DialogModeType, message: string, messageCode?: MessageCode, error?: any, description?: string, showLoginBtn?: boolean, disableClose?: boolean) {
    this.message = message;
    this.error = error;
    this.messageCode = messageCode;
    this.description = description;
    this.showLoginBtn = showLoginBtn;
    this.disableClose = disableClose;
    this.mode = mode;
  }
}
